import React from 'react';
import { ShowIf } from 'components/utils';
import { connect } from 'react-redux';
import { GiaiQuyetDonThu } from 'api';
import { DropDown, TextArea } from 'components/tt-forms/common';
import { validatable } from 'components/utils';
import { ContainerFileDinhKem } from 'components/upload';
import { msg } from "constants/message";
import { processType } from 'constants/process-type';

const process = [processType.xuLyDon.processing.trinhLanhDao];

class TrinhLanhDaoTTXM extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_TrinhLanhDaoTTXM: false,

      donId: this.props.donId,
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,

      dataGiaiQuyetDon: {},

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      lanhDaoChiDinh: '',
      noiDung: '',

      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
    }
  }

  componentWillMount() {
    this.checkState();
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';

    process.map((item, i) => {

      if (this.props.getState(this.props.listNextStates, item)) {

        onlyState = item;
        numberState++;

        switch (item) {

          case processType.xuLyDon.processing.trinhLanhDao:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_TrinhLanhDaoTTXM: true
            });
            break;
        }
      }
    });
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
  }

  getThongTinGiaiQuyetDon(thongTinGiaiQuyetDonId) {

    GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request({ id: thongTinGiaiQuyetDonId }).then(res => {
      if (res.data) {
        this.setState({
          dataGiaiQuyetDon: res.data,
          lanhDaoChiDinh: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
          noiDung: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
        });
      }
    }).then(() => {
      this.onlyOneState()
    });
  }

  onlyOneState() {
    if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState, true));
    }
  }

  handleChange(name, e) {
    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    this.setState({
      ...newState
    }, this.trigger(newState, false));
  }

  trigger(newState, isInit) {

    if (newState.form_TrinhLanhDaoTTXM) {

      let stateId = this.props.getState(this.props.listNextStates, 'TRINH_LANH_DAO');

      let paramsPatch = this.state.dataGiaiQuyetDon;

      if (newState.lanhDaoChiDinh)
        paramsPatch.canBoXuLyChiDinh = { id: Number(newState.lanhDaoChiDinh) };
      paramsPatch.yKienGiaiQuyet = newState.noiDung;

      paramsPatch.nextState = {
        id: Number(stateId),
        type: this.state.onlyState
      }

      let paramsPost = {};

      paramsPost.nextState = {
        id: Number(stateId),
        type: this.state.onlyState
      }

      if (newState.lanhDaoChiDinh)
        paramsPost.canBoXuLyChiDinh = { id: Number(newState.lanhDaoChiDinh) };

      paramsPost.yKienGiaiQuyet = newState.noiDung;

      paramsPost.thongTinGiaiQuyetDon = {
        id: this.props.thongTinGiaiQuyetDonId
      }

      let params = {
        paramsPatch: paramsPatch,
        paramsPost: paramsPost,
        notice: msg.gqdTrinhLanhDao
      }
      this.props.onChange(params, isInit);
    }
  }

  onFileRemove(id, data) {

    let temp = {
      dataFileDinhKem: data,
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    }

    this.setState({
      temp
    });



    this.props.onChangeTepDinhKem(temp.dataFileDinhKem, temp.dataTaiLieuVanThuDelete);
  }

  onFileChange(data) {
    this.setState({
      dataFileDinhKem: data
    });

    this.props.onChangeTepDinhKem(data, this.state.dataTaiLieuVanThuDelete);
  }

  render() {
    let ListTaiLieuVanThu = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => {
      return state.nguoiTaoInfo.donViId == this.state.donViId
    });

    let ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => {
      return state.nguoiTaoInfo.donViId != this.state.donViId
    });
    if (this.props.donInfo && this.props.donInfo.laTTXMLai) {
      ListTaiLieuVanThuShow = this.props.donInfo.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView;
    }
    return (
      <div className="items-form">
        <ShowIf condition={this.state.form_TrinhLanhDaoTTXM}>
          <div className="row pl10 pr10">
            <DropDown
              label="Ban lãnh đạo"
              options={this.props.lanhDaoList}
              keyName="congChucId"
              valueName="hoVaTen"
              bindValidator={this}
              require={!this.props.onSave}
              channel='formTaoDon'
              selectedValue={this.state.lanhDaoChiDinh}
              onChange={this.handleChange.bind(this, 'lanhDaoChiDinh')}
              placeholder={this.props.placeholder}
              name="chonBanlanhDaoTTXM" />
          </div>
          <div className="row pl10 pr10">
            <TextArea
              label="Ý kiến xử lý"
              value={this.state.noiDung}
              onChange={this.handleChange.bind(this, 'noiDung')}
              name="textareaBanLanhDaoTTXM" />
          </div>
          <div className="container-filedinhkem">
            <ContainerFileDinhKem label="Danh sách văn bản xử lý" disableAttachFile={true} bindValidator={this} dataShow={ListTaiLieuVanThuShow} data={ListTaiLieuVanThu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} onSave={this.props.onSave}/>
          </div>
        </ShowIf>
      </div>
    );
  }
}

TrinhLanhDaoTTXM.defaultProps = {
  listNextStates: [],
  validators: {
    formTaoDon: []
  },
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  onSave: false
}

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList
  }
}

export default connect(bindStateToProps)(validatable(TrinhLanhDaoTTXM));



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien-nhap-lieu/TrinhLanhDaoTTXM.jsx